<div class="one-group-header">
  <group-header (filter)="onFilter($event)"></group-header>
</div>
<div class=group-list *ngIf="!isLoading">
    <div class="list-header d-flex">
        <div class="p-2 total" style="width: 45%;">Nhóm ({{total}})</div>
        <div class="p-2 users flex-grow-1" style="width: 10%;">Người duyệt</div>
        <div class="p-2 ma flex-grow-1" style="width: 10%;">Y/c Qlý Trực tiếp</div>
        <div class="p-2 type flex-grow-1" style="width: 5%;">Quy trình</div>
        <div class="p-2 sla flex-grow-1" style="width: 5%;">SLA (G)</div>
        <div class="p-2 status flex-grow-1" style="width: 5%;">status</div>
    </div>
  <div class="group-list-data">
    <div class="group-section" *ngFor="let groupped of grouppedGroups">
        <div class="group-header d-flex">
            <div class="icon" style="width: 2%;" (click)="groupped.isExpanded = !groupped.isExpanded">
                <mat-icon *ngIf="groupped.isExpanded" class="icon-size-20 i" aria-hidden="false"
                    aria-label="Arrow bottom icon">keyboard_arrow_down</mat-icon>
                <mat-icon *ngIf="!groupped.isExpanded" class="icon-size-20 i" aria-hidden="false"
                    aria-label="Arrow right icon">keyboard_arrow_right</mat-icon>
            </div>
            <div class="name flex-grow-1">{{groupped.category}} ({{groupped.groups.length}})</div>
        </div>
        <div class="group-items" *ngIf="groupped.isExpanded">
            <group-li [group]="group" [users]="allUsers" [approvalTypes]="approvalTypes" *ngFor="let group of groupped.groups" [needRefresh]="status != null"></group-li>
        </div>
    </div>
    <div class="space-20"></div>
    <div class="space-20"></div>
    <div class="space-20"></div>
  </div>
</div>
